import React, { useEffect } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { withRouter } from 'react-router'
import { x, useDown } from '@xstyled/styled-components'
import useHasMounted from '../../lib/useHasMounted'

import Articles from '../components/Articles'
import { fetchArticles, fetchFullArticles, fetchMoreArticles } from '../../store/articles'
import { sectionPageView, setPageType } from '../../store/app'
import { getVisitorId, getSessionId } from '../../store/article'
import Ad from '../components/Ad'
import WingBanners from '../components/WingBanners'
import { FORMATS } from '../components/AdFormats'
import HomePageVideos from '../../templates/HomePageVideos'
import StyledLink from '../components/ui/Link'
import NotFound from './NotFound'
import NoImage from '../../../assets/images/general/no-image.png'
import next from '../../../assets/images/icons/gallery-next.svg'

import SecondaryNav from '../components/SecondaryNav'
import Oovvuu, { ErrorBoundary as OovvuuErrorBoundary } from '../components/Oovvuu'

const mapping1 = [
  [[1400, 0], [1, 2]],
  [[1200, 0], [1, 2]],
  [[1000, 0], [1, 2]],
  [[700, 0], [1, 2]],
  [[500, 0], [1, 2]],
  [[200, 0], [1, 2]],
  [[0, 0], []]
]

const mapping3 = [
  [[1400, 0], [[728, 90], [468, 60], [300, 250], [336, 280], 'fluid']],
  [[1400, 0], [[728, 90], [468, 60], [300, 250], [336, 280], 'fluid']],
  [[1000, 0], [[468, 60], [300, 250], [336, 280], [320, 50], [300, 100], [300, 50], 'fluid']],
  [[700, 0], [[468, 60], [320, 100], [320, 50], [300, 100], [300, 50], [300, 250], [336, 280], [250, 250], 'fluid']],
  [[500, 0], [[468, 60], [320, 100], [320, 50], [300, 100], [300, 50], [300, 250], [336, 280], [250, 250], 'fluid']],
  [[200, 0], [[320, 100], [320, 50], [300, 100], [300, 50], [300, 250], [300, 600], [336, 280], [250, 250], 'fluid']],
  [[0, 0], []]
]

const mapping5 = [
  [[1990, 0], [[300, 600], [300, 250], [336, 280], [250, 250], [120, 600], [160, 600]]],
  [[1690, 0], [[120, 600], [160, 600]]],
  [[1000, 0], []],
  [[700, 0], []],
  [[500, 0], []],
  [[200, 0], []],
  [[0, 0], []]
]

const VideoPanel = () => {
  return (
    <x.div w='100%' maxWidth={1220} mx='auto' mt={50} mb={50} zIndex='100'>
      <x.div className='video-box'>
        <OovvuuErrorBoundary>
          <Oovvuu uuid='0c22c5c1-2183-411e-8c7c-0fb74057b710' isLast={false} />
        </OovvuuErrorBoundary>
      </x.div>
    </x.div>
  )
}

export const Skeleton = () => {
  return (
    <x.div w='100%' px={20} mx='auto' mt={50} mb={50}>
      <x.div w='100%' h={495} bg='#F0F0F0'></x.div>
    </x.div>
  )
}

const VideoPage = (props) => {
  const hasMounted = useHasMounted()
  const downMd = useDown('md')
  const clickSource = 'Video Page'
  setPageType('section')
  useEffect(
    () => {
      props.sectionPageView(props.location.pathname, props.section, props.visitorId, props.sessionId, props.app.firstRender)
      const path = `/${process.env.RAZZLE_DFP_CODE}${props.adPath || (props.location.pathname === '/' ? '/homepage' : props.location.pathname)}`
      const descriptionUrl = `description_url=${encodeURIComponent(window.location.href)}`
      const custParams = 'cust_params=title%3d{mediainfo.name}%26description%3d{mediainfo.description}%26keywords%3d{mediainfo.tags}'
      window.oovvuuReplacementAdServerURL = `https://pubads.g.doubleclick.net/gampad/ads?iu=${path}&sz=640x480&${custParams}&ciu_szs=300x250&gdfp_req=1&ad_rule=1&ad_type=video&output=vmap&unviewed_position_start=1&env=vp&impl=s&correlator=&${descriptionUrl}&vpmute=1&plcmt=1`
    },
    [props.section]
  )
  return (
    <>
      <x.main px={20} mt={{ sm: '96px', lg: '173px' }} w='100%' className='video-page'>
        <Ad isConnected={props.isConnected} adPath={props.adPath} slotId='third-party' targeting={{ Pos: 'Third-Party' }} collapseEmptyDiv className='advert' mapping={mapping1} {...FORMATS.thirdParty} />
        <WingBanners isConnected={props.isConnected} adPath={props.adPath} location={props.location} mappingLeft={mapping5} mappingRight={mapping5} onSlotRenderEndedLeft={props.onSlotRenderEndedLeft} onSlotRenderEndedRight={props.onSlotRenderEndedRight} />
        <SecondaryNav section={props.section} sectionLabel={props.sectionLabel} relatedSections={props.relatedSections} sessionId={props.sessionId} visitorId={props.visitorId} />
        {/* Video panel */}
        <VideoPanel />
        {/* Start of OOVVUU Collections */}
        <x.div maxWidth={1220} w='100%' mx='auto'>
          <x.div position='relative' w='100%'>
            <x.h3 text='h3' borderWidth='0 0 1px 0' borderStyle='solid' borderColor='divider' pb={10} mb={20}>Podcasts</x.h3>
            <StyledLink to='/multimedia/podcasts' position='absolute' top='50%' right='0' transform='translateY(-50%)' textTransform='uppercase' text='small' color={{ hover: 'red' }} display='flex' justifyContent='center' alignItems='center' flexDirection='row' sessionId={props.sessionId} visitorId={props.visitorId} section={props.section} source={clickSource}>More <x.img src={next} w='24px' h='24px' /></StyledLink>
          </x.div>
          <x.div maxWidth={1220} w='100%' mx='auto' mb={50}>
            <Articles
              {...props} noDiv section='multimedia/podcasts' count={4} pageSize={4} noImage={NoImage} notFound={NotFound} component={({ articles, section, noImage, isConnected, withReadCount }) => (
                <HomePageVideos articles={articles} section={section} noImage={noImage} isConnected={isConnected} withReadCount={withReadCount} adPath={props.adPath} sessionId={props.sessionId} visitorId={props.visitorId} />
              )}
            />
          </x.div>
        </x.div>
        <x.div maxWidth={1220} w='100%' mx='auto'>
          <x.div position='relative' w='100%'>
            <x.h3 text='h3' borderWidth='0 0 1px 0' borderStyle='solid' borderColor='divider' pb={10} mb={20}>News</x.h3>
            <StyledLink to='/news/video' position='absolute' top='50%' right='0' transform='translateY(-50%)' textTransform='uppercase' text='small' color={{ hover: 'red' }} display='flex' justifyContent='center' alignItems='center' flexDirection='row' sessionId={props.sessionId} visitorId={props.visitorId} section={props.section} source={clickSource}>More <x.img src={next} w='24px' h='24px' /></StyledLink>
          </x.div>
          <x.div maxWidth={1220} w='100%' mx='auto' mb={50}>
            <Articles
              {...props} noDiv section='news/video' count={4} pageSize={4} noImage={NoImage} notFound={NotFound} component={({ articles, section, noImage, isConnected, withReadCount }) => (
                <HomePageVideos articles={articles} section={section} noImage={noImage} isConnected={isConnected} withReadCount={withReadCount} adPath={props.adPath} sessionId={props.sessionId} visitorId={props.visitorId} />
              )}
            />
          </x.div>
          <x.div maxWidth={1220} w='100%' mx='auto'>
            <OovvuuErrorBoundary>
              <Oovvuu uuid='4c0314aa-87fa-4a57-8152-521cc269c23c' isLast={false} />
            </OovvuuErrorBoundary>
          </x.div>
        </x.div>
        <x.div mt={20} mb={50} mx={-20} textAlign='center' display='flex' justifyContent='center' alignItems='center' flexDirection='column'>
          <Ad isConnected={props.isConnected} adPath={props.adPath} collapseEmptyDiv slotId='Leaderboard-1' targeting={{ Pos: 'Leaderboard-1' }} className='advert' mapping={mapping3} {...FORMATS.leaderboard} />
        </x.div>
        <x.div maxWidth={1220} w='100%' mx='auto'>
          <x.div position='relative' w='100%'>
            <x.h3 text='h3' borderWidth='0 0 1px 0' borderStyle='solid' borderColor='divider' pb={10} mb={20}>Lifestyle</x.h3>
            <StyledLink to='/lifestyle/video' position='absolute' top='50%' right='0' transform='translateY(-50%)' textTransform='uppercase' text='small' color={{ hover: 'red' }} display='flex' justifyContent='center' alignItems='center' flexDirection='row' sessionId={props.sessionId} visitorId={props.visitorId} section={props.section} source={clickSource}>More <x.img src={next} w='24px' h='24px' /></StyledLink>
          </x.div>
          <x.div maxWidth={1220} w='100%' mx='auto' mb={50}>
            <Articles
              {...props} noDiv section='lifestyle/video' count={4} pageSize={4} noImage={NoImage} notFound={NotFound} component={({ articles, section, noImage, isConnected, withReadCount }) => (
                <HomePageVideos articles={articles} section={section} noImage={noImage} isConnected={isConnected} withReadCount={withReadCount} adPath={props.adPath} sessionId={props.sessionId} visitorId={props.visitorId} />
              )}
            />
          </x.div>
          <x.div maxWidth={1220} w='100%' mx='auto'>
            <OovvuuErrorBoundary>
              <Oovvuu uuid='63e25e40-26bd-4cd0-95c2-52a64415b4a1' isLast={false} />
            </OovvuuErrorBoundary>
          </x.div>
        </x.div>
        <x.div maxWidth={1220} w='100%' mx='auto'>
          <x.div position='relative' w='100%'>
            <x.h3 text='h3' borderWidth='0 0 1px 0' borderStyle='solid' borderColor='divider' pb={10} mb={20}>Sport</x.h3>
            <StyledLink to='/sport/video' position='absolute' top='50%' right='0' transform='translateY(-50%)' textTransform='uppercase' text='small' color={{ hover: 'red' }} display='flex' justifyContent='center' alignItems='center' flexDirection='row' sessionId={props.sessionId} visitorId={props.visitorId} section={props.section} source={clickSource}>More <x.img src={next} w='24px' h='24px' /></StyledLink>
          </x.div>
          <x.div maxWidth={1220} w='100%' mx='auto' mb={50}>
            <Articles
              {...props} noDiv section='sport/video' count={4} pageSize={4} noImage={NoImage} notFound={NotFound} component={({ articles, section, noImage, isConnected, withReadCount }) => (
                <HomePageVideos articles={articles} section={section} noImage={noImage} isConnected={isConnected} withReadCount={withReadCount} adPath={props.adPath} sessionId={props.sessionId} visitorId={props.visitorId} />
              )}
            />
          </x.div>
          <x.div maxWidth={1220} w='100%' mx='auto'>
            <OovvuuErrorBoundary>
              <Oovvuu uuid='65bffbfe-6016-44eb-91b4-e616cd6d34bc' isLast={false} />
            </OovvuuErrorBoundary>
          </x.div>
        </x.div>
        <x.div mt={20} mb={50} mx={-20} textAlign='center' display='flex' justifyContent='center' alignItems='center' flexDirection='column'>
          <Ad isConnected={props.isConnected} adPath={props.adPath} collapseEmptyDiv slotId='Leaderboard-2' targeting={{ Pos: 'Leaderboard-2' }} className='advert' mapping={mapping3} {...FORMATS.leaderboard} />
        </x.div>
        <x.div maxWidth={1220} w='100%' mx='auto'>
          <x.div position='relative' w='100%'>
            <x.h3 text='h3' borderWidth='0 0 1px 0' borderStyle='solid' borderColor='divider' pb={10} mb={20}>Politics</x.h3>
            <StyledLink to='/news/politics/video' position='absolute' top='50%' right='0' transform='translateY(-50%)' textTransform='uppercase' text='small' color={{ hover: 'red' }} display='flex' justifyContent='center' alignItems='center' flexDirection='row' sessionId={props.sessionId} visitorId={props.visitorId} section={props.section} source={clickSource}>More <x.img src={next} w='24px' h='24px' /></StyledLink>
          </x.div>
          <x.div maxWidth={1220} w='100%' mx='auto' mb={50}>
           <Articles
              {...props} noDiv section='news/politics/video' count={4} pageSize={4} noImage={NoImage} notFound={NotFound} component={({ articles, section, noImage, isConnected, withReadCount }) => (
                <HomePageVideos articles={articles} section={section} noImage={noImage} isConnected={isConnected} withReadCount={withReadCount} adPath={props.adPath} sessionId={props.sessionId} visitorId={props.visitorId} />
              )}
            />
          </x.div>
          <x.div maxWidth={1220} w='100%' mx='auto'>
            <OovvuuErrorBoundary>
              <Oovvuu uuid='b3748041-0465-4d72-894f-098a305a51fc' isLast={false} />
            </OovvuuErrorBoundary>
          </x.div>
        </x.div>
        <x.div maxWidth={1220} w='100%' mx='auto'>
          <x.div position='relative' w='100%'>
            <x.h3 text='h3' borderWidth='0 0 1px 0' borderStyle='solid' borderColor='divider' pb={10} mb={20}>Business</x.h3>
            <StyledLink to='/business-report/video' position='absolute' top='50%' right='0' transform='translateY(-50%)' textTransform='uppercase' text='small' color={{ hover: 'red' }} display='flex' justifyContent='center' alignItems='center' flexDirection='row' sessionId={props.sessionId} visitorId={props.visitorId} section={props.section} source={clickSource}>More <x.img src={next} w='24px' h='24px' /></StyledLink>
          </x.div>
          <x.div maxWidth={1220} w='100%' mx='auto' mb={50}>
            <Articles
              {...props} noDiv section='business-report/video' count={4} pageSize={4} noImage={NoImage} notFound={NotFound} component={({ articles, section, noImage, isConnected, withReadCount }) => (
                <HomePageVideos articles={articles} section={section} noImage={noImage} isConnected={isConnected} withReadCount={withReadCount} adPath={props.adPath} sessionId={props.sessionId} visitorId={props.visitorId} />
              )}
            />
          </x.div>
          <x.div maxWidth={1220} w='100%' mx='auto'>
            <OovvuuErrorBoundary>
              <Oovvuu uuid='db511caa-6b67-4b65-ae86-24321a382e54' isLast={true} />
            </OovvuuErrorBoundary>
          </x.div>
        </x.div>
        {/* End of OOVVUU Collection */}
        <x.div mt={20} mb={50} mx={-20} textAlign='center' display='flex' justifyContent='center' alignItems='center' flexDirection='column'>
          <Ad isConnected={props.isConnected} adPath={props.adPath} collapseEmptyDiv slotId='Leaderboard-3' targeting={{ Pos: 'Leaderboard-3' }} className='advert' mapping={mapping3} {...FORMATS.leaderboard} />
        </x.div>
      </x.main>
    </>
  )
}

VideoPage.defaultProps = {
  section: 'multimedia/videos'
}
const mapDispatchToProps = (dispatch) => bindActionCreators({ fetchArticles, fetchFullArticles, fetchMoreArticles, sectionPageView }, dispatch)

export default withRouter(connect((state) => ({ app: state.app, articles: state.articles, visitorId: getVisitorId(state), sessionId: getSessionId(state) }), mapDispatchToProps)(VideoPage))
